import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioResolucion1552Service {

  constructor(private requestUrl: ReportesRequestService) { }

  async getInfoEmpresa(objetoFiltro: DatosBaseResolucionEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'resolucion1552/sedes',
        [objetoFiltro.codigoBaseDatos, { unco_sede: objetoFiltro.uncoSede }]
      );
      return response;

    } catch (e) {
      console.log(`ServicioResolucion1552Service.getSedes() ${e}`);
    }
    return null;
  }

  async getEntidadEmpresarial(codigoBaseDatos: DatosBaseResolucionEntity, uncoEntidadEmpresarial: number) {
    try {
      const response = await this.requestUrl.getRequest(
        'entidad-empresarial/datos-entidad',
        [codigoBaseDatos.codigoBaseDatos, { unco_entidad_empresarial: uncoEntidadEmpresarial }]
      );
      return response;

    } catch (e) {
      alert(e);
      // console.log(`ServicioResolucion1552Service.getEntidadEmpresarial() ${e}`);
    }
    return null;
  }

  async getSedes(objetoFiltro: DatosBaseResolucionEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'resolucion1552/sedes',
        [objetoFiltro.codigoBaseDatos, { unco_sede: objetoFiltro.uncoSede }]
      );
      return response;

    } catch (e) {
      console.log(`ServicioResolucion1552Service.getSedes() ${e}`);
    }

    return null;
  }

  async getPuntosAtencion(codigo: string, uncoLogin: number, uncoSede: string) {
    try {
      const codigoBaseDatos = codigo;
      const response = await this.requestUrl.getFilterRequest(
        'resolucion1552/puntos-atencion',
        [codigoBaseDatos, { unco_login: uncoLogin, unco_sede: uncoSede }]
      );

      return response;

    } catch (e) {
      console.log(`ServicioResolucion1552Service.getpuntos-atencion() ${e}`);
    }

    return null;
  }

  async getLineaProducto(codigo: string, uncoSede: string, uncoPuntoAtencion: string) {
    try {
      const codigoBaseDatos = codigo;
      const response = await this.requestUrl.getFilterRequest(
        'resolucion1552/linea-productos',
        [codigoBaseDatos, { lc_unco_sede: uncoSede, lc_unco_pnto_atncn: uncoPuntoAtencion }]
      );
      return response;
    } catch (e) {
      console.log(`ServicioResolucion1552Service.getLineaProducto() ${e}`);
    }
    return null;
  }

  async getProcedimiento(CodigoBD: string, uncoLineaProducto: string) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'resolucion1552/procedimientos',
        [CodigoBD, { ln_unco_ln_prdcto: uncoLineaProducto }]
      );
      return response;
    } catch (e) {
      console.log(`ServicioResolucion1552Service.getProcedimiento() ${e}`);
    }
    return null;
  }

  async getEmpresa(CodigoBD: string) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'resolucion1552/empresas',
        [CodigoBD]
      );

      return response;

    } catch (e) {
      console.log(`ServicioResolucion1552Service.getEmpresa() ${e}`);
    }

    return null;
  }

  async getConsolidadoData(objetoReporte: FiltrosResolucionEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'resolucion1552/reporte-resolucion1552',
        [
          objetoReporte.codigoBaseDatos,

          {
            'ld_fcha_incl': objetoReporte.fechaInicial,
            'ld_fcha_fnl': objetoReporte.fechaFinal,
            'lc_unco_sede': objetoReporte.sede,
            'lc_unco_pnto_atncn': objetoReporte.puntoAtencion,
            'ln_unco_ln_prdcto': objetoReporte.lineaProducto,
            'lc_unco_prcdmnto': objetoReporte.procedimiento,
            'lc_unco_emprsa': objetoReporte.empresa,
          }
        ]);
      return response;
    } catch (e) {
      console.log(`ServicioResolucion1552Service.getConsolidadoData() ${e}`);
    }
  }
}

export interface EntidadEmpresarial {
  unco: number;
  nombreEntidad: string;
  nit: string;
  direccion: number;
  telefono: string;
}

export interface Sedes {
  unco: number;
  descripcionCorta: string;
  descripcion: string;

}

export interface PuntoAtencion {
  unco: number;
  descripcion: string;
}

export interface LineaProducto {
  unco: number;
  descripcionCorta: string;
}

export interface Procedimiento {
  unco: number;
  descripcionCorta: string;
}

export interface Empresa {
  unco: number;
  descripcionCorta: string;
  descripcionLarga: string;
  direccion: string;
  telefono: string;
  nit: string;
}

export interface DatosBaseResolucionEntity {
  codigoBaseDatos: string;
  uncoSede: string;
  uncoLogin: number;
  uncoPuntoAtencion: string;
  uncoProcedimiento: string;
  uncoEntidad: string;
}
export interface DatosBaseResolucionEntity {
  codigoBaseDatos: string;
  uncoSede: string;
}

export interface FiltrosResolucionEntity {
  codigoBaseDatos: string;
  fechaInicial: number;
  fechaFinal: number;
  sede: string;
  puntoAtencion: string;
  lineaProducto: string;
  procedimiento: string;
  empresa: string;
}

export interface FiltrosResolucionBodyEntity {
  codigoEps: string;
  primerNombreAfiliado: string;
  segundoNombreAfiliado: string;
  primerApellidoAfiliado: string;
  segundoApellidoAfiliado: string;
  tipoDocumento: string;
  numeroIdentificacion: string;
  departamento: string;
  municipio: string;
  direccion: string;
  telefono: string;
  fechaAsignacionCita: Date;
  fechaDeseadaUsuario: Date;
  fechaCita: Date;
  codigoHabilitado: string;
  servicioHabilitado: string;
  servicio: string;
  codigoRepss: string;
  numeroTotalCitas: string;
  fechaCitaFechaAsignada: number;
  fechaAsignadaFechaDeseada: number;
  estadoCita: string;
  empresa: string;
}

export interface FiltrosResolucionExcelEntity {
  codigoEps: string;
  primerNombreAfiliado: string;
  segundoNombreAfiliado: string;
  primerApellidoAfiliado: string;
  segundoApellidoAfiliado: string;
  tipoDocumento: string;
  numeroIdentificacion: string;
  departamento: string;
  municipio: string;
  direccion: string;
  telefono: string;
  fechaAsignacionCita: Date;
  fechaDeseadaUsuario: Date;
  fechaCita: Date;
  codigoHabilitado: string;
  servicioHabilitado: string;
  servicio: string;
  codigoRepss: string;
  numeroTotalCitas: string;
  fechaCitaFechaAsignada: number;
  fechaAsignadaFechaDeseada: number;
  estadoCita: string;
  empresa: string;
}

export interface DatosAgrupadosResolucion1552 {
  empresa: string;
  datos: FiltrosResolucionBodyEntity[];
}
